import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function CryptoDigitalAssetLicenseSeychelles() {

    return (
        <main className='main'>

            <IntroSection
                title="Crypto & Digital Asset License – Seychelles"
                subtitle="Launch Exchanges, Wallets & Token Projects in a Global Offshore Hub"
                description="<b>Seychelles</b> is a <b>leading jurisdiction</b> for <b>cryptocurrency and digital asset businesses</b>, regulated by the <b>Financial Services Authority (FSA)</b>."
                listSubtitle='While there is no dedicated “crypto law,” most crypto businesses operate under:'
                listItems={
                    [
                        "The Securities Dealer License (SDL) — for exchanges, trading platforms, token offerings",
                        "The Payment Service Provider (PSP) License — for crypto payment gateways and wallets"
                    ]
                }
                badges={
                    [
                        "Crypto Exchanges",
                        "Wallets & Custody",
                        "Token Issuance",
                        "Crypto PSPs"
                    ]
                }
                buttonText="Request a Seychelles Crypto Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Seychelles for Crypto?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Proven Track Record",
                                                text: "Used by many Tier-1 crypto exchanges."
                                            },
                                            {
                                                title: "Flexible Regulation",
                                                text: "FSA licenses adapted to crypto."
                                            },
                                            {
                                                title: "Low Entry Barriers",
                                                text: "Compared to Malta, Gibraltar, or EU MiCA."
                                            },
                                            {
                                                title: "Tax Neutrality",
                                                text: "No tax on foreign-sourced crypto income."
                                            },
                                            {
                                                title: "Banking & PSP Access",
                                                text: "Stronger than unlicensed offshore setups."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Crypto Structures in Seychelles"
                        subtitle=''
                        blocks={
                            [
                                {
                                    title: "Crypto Exchange License (Securities Dealer)",
                                    items:
                                        [
                                            {
                                                text: "Covers spot & derivatives trading of digital assets."
                                            },
                                            {
                                                text: "Allows operation of centralized exchanges (CEXs)."
                                            },
                                            {
                                                text: "Popular choice for global crypto platforms."
                                            }
                                        ]
                                },
                                {
                                    title: "Wallet & Custody Providers",
                                    items:
                                        [
                                            {
                                                text: "Can operate under PSP/MSB licenses."
                                            },
                                            {
                                                text: "Secure custody solutions for retail & institutional clients."
                                            }
                                        ]
                                },
                                {
                                    title: "Token Issuance (ICOs, STOs, NFTs)",
                                    items:
                                        [
                                            {
                                                text: "Token projects structured under Securities Dealer if tokens qualify as securities."
                                            },
                                            {
                                                text: "ICO/STO launchpads legally registered."
                                            }
                                        ]
                                },
                                {
                                    title: "Crypto Payment Gateways & PSPs",
                                    items:
                                        [
                                            {
                                                text: "Crypto-to-fiat payment rails."
                                            },
                                            {
                                                text: "Hybrid PSP + crypto gateway models allowed."
                                            }
                                        ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Securities Dealer (Crypto Exchange)",
                                    text: "USD 50,000."
                                },
                                {
                                    title: "PSP (Crypto Payments)",
                                    text: "USD 50,000–100,000."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Seychelles IBC or local entity required."
                                },
                                {
                                    title: "Resident Director & Compliance Officer",
                                    text: "Mandatory."
                                },
                                {
                                    title: "AML/KYC Policies",
                                    text: "Aligned with FATF standards (critical for crypto)."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Seychelles Crypto License'
                        services={
                            [
                                {
                                    title: "Global Popularity",
                                    text: "Used by major exchanges."
                                },
                                {
                                    title: "Flexible Structures",
                                    text: "Exchanges, wallets, PSPs, token issuers."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Better chance vs unlicensed offshore."
                                },
                                {
                                    title: "Cost-Effective",
                                    text: "USD 50k capital vs millions in Malta/EU."
                                },
                                {
                                    title: "Tax-Free",
                                    text: "No tax on foreign crypto transactions."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define exchange, wallet, token, or PSP model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register a Seychelles IBC."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Business plan, AML/KYC policies, governance docs."
                                },
                                {
                                    title: "FSA Review",
                                    text: "Due diligence on directors, shareholders, compliance."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "3–6 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 40,000+ (legal, compliance, licensing)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 50k–100k depending on license type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "regulator fees, compliance, audits."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Crypto licensing specialists with Seychelles experience."
                                },
                                {
                                    text: "End-to-end setup: incorporation, SDL/PSP licensing, compliance manuals."
                                },
                                {
                                    text: "Introductions to crypto-friendly banks, PSPs, and exchanges."
                                },
                                {
                                    text: "Comparative insights: Seychelles vs Malta vs Gibraltar vs Western Sahara."
                                },
                                {
                                    text: "Long-term compliance support (AML audits, FATF updates)."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a crypto exchange, wallet, or token project?"
                        description="Seychelles offers flexible crypto licensing through FSA, trusted by the world’s top exchanges."
                        buttonText="Book a Seychelles Crypto License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Does Seychelles have a dedicated crypto law?",
        content: [
            { type: "answer", text: "No — crypto firms operate under Securities Dealer or PSP licenses." },
        ],
    },
    {
        question: "Can I run a crypto exchange from Seychelles?",
        content: [
            { type: "answer", text: "Yes — via the Securities Dealer License (USD 50k capital)." },
        ],
    },
    {
        question: "What’s the capital requirement?",
        content: [
            { type: "answer", text: "USD 50k–100k depending on business scope." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 3–6 months." },
        ],
    },
    {
        question: "Why do so many exchanges choose Seychelles?",
        content: [
            { type: "answer", text: "Lower cost, FSA credibility, tax neutrality, global flexibility." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "We launched our crypto exchange under Seychelles FSA. Offshore Advisory managed SDL licensing and AML compliance.",
            author: "Jason T.",
            role: "Exchange Founder"
        },
        {
            quote: "Seychelles gave us legitimacy for our crypto PSP business. Offshore Advisory connected us with banks and PSP partners.",
            author: "Lina S.",
            role: "FinTech CEO"
        }
    ]
;